export default __webpack_public_path__ + "static/iosQrcode-78cd80399cd6146b64593465b1b83b9e.jpeg";